import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { WebSocketProvider } from "./context/WebSocketContext";
// Sentry init ANTES del render — Round C 2026-04-28. Si
// REACT_APP_SENTRY_DSN está en el bundle, captura errores; sin DSN
// es no-op.
import { initSentry } from "./config/sentry";
// Recuperación automática ante chunks obsoletos tras un deploy: si una falla de
// carga de chunk escapa como promesa rechazada (típico de chunks CSS), recarga
// una vez para bajar el bundle nuevo. Ver utils/chunkReload.ts.
import { installChunkErrorAutoReload } from "./utils/chunkReload";
// Captura de `beforeinstallprompt` (instalar la app en Android). Chrome lo dispara UNA vez y puede ser antes de que React
// monte, así que el listener se registra acá, antes del render. Lo usa Components/InstalarAppAviso. Ver utils/instalacionPwa.ts.
import { iniciarCapturaInstalacion } from "./utils/instalacionPwa";

iniciarCapturaInstalacion();
initSentry();
installChunkErrorAutoReload();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <WebSocketProvider>
        <App />
      </WebSocketProvider>
    </AuthProvider>
  </React.StrictMode>
);

// Web Vitals → Sentry. Reporta vitals con rating "poor" como issues
// individuales en sentry.io (la integración auto-captura CLS/LCP/FID
// como measurements de pageload, pero esto sí permite alertar sobre
// experiencias degradadas concretas). Ver `reportWebVitals.ts`.
reportWebVitals();
